<template>
  <div class="upload-wrap">
    <el-upload
      class="upload-area"
      :class="{ 'show-list': messageImgs.length > 0 }"
      :action="uploadApi"
      :headers="headers"
      :file-list="fileList"
      list-type="picture-card"
      :on-exceed="handleExceed"
      :before-upload="beforeUpload"
      :on-success="handleSuccess"
      :on-change="handleEditChange"
      :on-remove="handleRemove"
      :on-error="handleError"
      name="uploadFile"
      :data="params"
      :multiple="true"
      :drag="true"
      :limit="limit"
      show-file-list
    >
      <i class="el-icon-plus"></i>
      <div slot="file" slot-scope="{ file }">
        <img
          class="el-upload-list__item-thumbnail"
          @click="clickbanner"
          :src.sync="file.url"
          @error="imgError(file)"
          alt="图片"
        />
        <i class="el-icon-error" @click="handleRemove(file)"></i>
        <div v-if="file.status == 'success'" class="tip">上传成功</div>
        <div v-else class="tip">上传中</div>
      </div>
    </el-upload>
  </div>
</template>

<script>
import uploadImg from "src/mixins/uploadImg";
export default {
  name: "upload-image-message",
  mixins: [uploadImg],
  computed: {
    ...mapState({
      messageImgs: state => state.chat.messageImgs
    })
  },
  methods: {
    imgError(file) {
      this.$message.closeAll();
      this.$message.error("文件无效（0kb）或格式不正确，请重新选择正确文件");
      this.handleRemove(file);
      this.$store.commit("setState", {
        isMsgUpload: false
      });
      this.fileList.forEach(element => {
        if (element.status != "success") {
          this.$store.commit("setState", {
            isMsgUpload: true
          });
          return false;
        }
      });
    },
    removeImg() {
      clearTimeout(this.time);
      this.time = setTimeout(() => {
        this.hideUploadEdit = this.fileList.length >= this.limit;
      }, 500);
    },
    handleEditChange(file, fileList) {
      this.fileList = fileList;
      console.log(file, fileList, fileList.length);
      let len = 0;
      fileList.forEach(element => {
        if (element.status == "success") {
          len++;
        }
      });
      console.log("gaibian", fileList.length, "===", len);
      if (fileList.length == len) {
        this.$store.commit("setState", {
          isMsgUpload: false
        });
      } else {
        this.$store.commit("setState", {
          isMsgUpload: true
        });
      }
      this.hideUploadEdit = fileList.length >= this.limit;
    },
    clickbanner(e) {
      console.log(e);
      this.$parent.clickbanner(e);
    }
  }
};
</script>

<style lang="less" scoped>
.tip {
  color: #fff;
  z-index: 64;
  position: absolute;
  bottom: 0;
  width: 100%;
  text-align: center;
  background: rgba(0, 0, 0, 0.8);
  height: 16px;
  line-height: 16px;
  font-size: 11px;
}
.upload-wrap {
  width: 100%;
  height: 100%;

  /deep/ .upload-area {
    &.show-list {
      .el-upload-list {
        right: 0;
        border-top: 1px solid #e7e7e7;
      }

      .el-upload-list__item {
        margin: 10px 0px 10px 10px;
      }
    }

    .el-upload-list {
      position: absolute;
      top: -81px;
      background: #f3f3f3;
      left: 0;
      width: auto;
      max-width: 100%;
      white-space: nowrap;
      height: 80px;
      border-radius: 5px;
      /*z-index:999;*/
      overflow-y: hidden;
      overflow-x: auto;
    }

    .el-upload-list__item {
      display: inline-block;
      margin: 10px 0px 10px 10px;
      width: 60px;
      height: 60px;
      position: relative;

      img {
        max-width: 100%;
        height: auto;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
      }
    }

    .el-upload--picture-card {
      width: 20px;
      height: 20px;
      opacity: 0;
      border: 0px dashed var(--loadimg-add-icon);
      position: relative;
      .el-upload-dragger {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      // input[type="file"]{
      //   width: 100%;
      //   height: 100%;
      //   position: absolute;
      //   left: 0;
      //   top: 0;
      // }
    }
  }
}
</style>
